import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Flex, Spinner, Text } from "@radix-ui/themes";
import { completeHubRiseOAuth } from "../../../api/QrOrderingApi";
import { consumeOAuthAttempt } from "./oauthSession";

export function HubRiseCallback() {
  const started = useRef(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const existing = document.querySelector('meta[name="referrer"]');
    const meta = existing || document.createElement("meta");
    const previous = meta.content;
    meta.name = "referrer";
    meta.content = "no-referrer";
    if (!existing) document.head.appendChild(meta);

    return () => {
      if (existing) meta.content = previous;
      else meta.remove();
    };
  }, []);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const params = new URLSearchParams(window.location.search);
    // Remove the one-use code before any asynchronous work; do not log it.
    window.history.replaceState(window.history.state, "", window.location.pathname);

    const complete = async () => {
      try {
        const attempt = consumeOAuthAttempt(params);
        const response = await completeHubRiseOAuth(attempt.locationId, attempt.payload);
        if (!response.data?.connection) throw new Error("The server did not confirm the connection. Please try again.");
        setResult(response.data.connection);
      } catch (err) {
        setError(err.response?.status === 401 ? "Your session has expired. Sign in and start a new connection." : err.response?.data?.detail || err.message || "Could not complete the HubRise connection. Please try again.");
      }
    };
    complete();
  }, []);

  return (
    <Flex justify="center" align="center" style={{ display: "flex", minHeight: "100dvh", width: "100%", padding: 24, boxSizing: "border-box" }}>
      <Card style={{ maxWidth: 480, width: "100%" }}>
        <Flex direction="column" gap="4" style={{ display: "flex", ...(!result && !error ? { alignItems: "center", textAlign: "center", padding: "16px 8px" } : {}) }}>
          {error ? <>
            <Text size="5" weight="bold">HubRise connection failed</Text>
            <Text role="alert" color="red">{error}</Text>
          </> : result ? <>
            <Text size="5" weight="bold">HubRise connected</Text>
            <Text>Location: {result.hubrise_location_name || result.hubrise_location_id}</Text>
            <Text>Catalog: {result.catalog_name || result.catalog_id}</Text>
            <Text size="2" color="gray">Your connection is saved. Menu import and order delivery are the next steps.</Text>
          </> : <>
            <Spinner size="3" />
            <Text>Connecting to HubRise…</Text>
          </>}
          {(result || error) && <Button asChild><Link to="/integrations/browse-all">Back to Integrations</Link></Button>}
        </Flex>
      </Card>
    </Flex>
  );
}
